import React from 'react';
import { Box, Typography, Container} from '@mui/material';

const Footer = ( {sx}) => {
        return (
          <Box 
            sx={{ 
              backgroundColor: '#333', 
              color: 'white', 
              padding: '5px 0', 
              maxHeight:32 , 
              my:0.5, 
              width:'100%',
              paddingBottom: 'env(safe-area-inset-bottom)', // <-- Safe margin for mobile
              ...sx,
             }}>
          <Container sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" >&copy; 2026 Polyglot Hub, LLC</Typography>
            {/* <Box>
              <Button color="inherit" component={Link} to="/terms">Terms of Service</Button>
              <Button color="inherit" component={Link} to="/privacy">Privacy Policy</Button>
            </Box> */}
          </Container>
        </Box>
    );
    };

export default Footer;